/*
 * <gift-option> — order-level "Send as gift" toggle + gift message.
 *
 * Persists to cart attributes via /cart/update.js:
 *   attributes["Send as gift"]  -> "Yes" | ""
 *   attributes["Gift message"]  -> string | ""
 *
 * Independent of line items; unaffected by add / remove / quantity changes.
 * Re-upgrades automatically when the cart drawer / footer HTML is re-rendered.
 */
if (!customElements.get('gift-option')) {
  customElements.define(
    'gift-option',
    class GiftOption extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector('.gift-option__checkbox');
        this.fields = this.querySelector('.gift-option__fields');
        this.textarea = this.querySelector('.gift-option__textarea');
        this.counter = this.querySelector('[data-gift-count]');
        this.max = parseInt(this.dataset.max, 10) || 250;
        this.debounceTimer = null;
      }

      connectedCallback() {
        if (!this.checkbox || this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';

        this.checkbox.addEventListener('change', () => {
          this.toggleFields();
          this.save();
        });

        if (this.textarea) {
          this.textarea.addEventListener('input', () => {
            this.updateCounter();
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => this.save(), 400);
          });
        }
      }

      toggleFields() {
        const on = this.checkbox.checked;
        this.checkbox.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (this.fields) this.fields.hidden = !on;
        if (!on && this.textarea) {
          this.textarea.value = '';
          this.updateCounter();
        }
      }

      updateCounter() {
        if (!this.counter || !this.textarea) return;
        this.counter.textContent = `${this.textarea.value.length}/${this.max} characters`;
      }

      save() {
        const isGift = this.checkbox.checked;
        const message = isGift && this.textarea ? this.textarea.value.trim() : '';

        const body = JSON.stringify({
          attributes: {
            'Send as gift': isGift ? 'Yes' : '',
            'Gift message': message,
          },
        });

        const config =
          typeof fetchConfig === 'function'
            ? fetchConfig()
            : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };

        const url = (window.routes && window.routes.cart_update_url) || '/cart/update.js';

        this.setBusy(true);
        fetch(url, { ...config, body })
          .catch(() => {})
          .finally(() => this.setBusy(false));
      }

      setBusy(state) {
        this.toggleAttribute('aria-busy', state);
      }
    }
  );
}
